module.exports = __webpack_public_path__ + "img/flowers_2.ed44e31.webp";